import { useState } from "react";
import { UserRound, Check, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { escalate } from "./assistApi";
import { formatApiError } from "@/lib/api";

export const HumanButton = ({ t, sessionId, ticketId, onDone, demo }) => {
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  if (demo || !sessionId) return null;
  if (ticketId) {
    return (
      <button onClick={() => nav("/support")} data-testid="assist-ticket-link" className="w-full flex items-center justify-center gap-2 text-xs text-[#22e3a1] py-2">
        <Check className="w-3.5 h-3.5" />{t("as.sent")}
      </button>
    );
  }
  const go = async () => {
    setBusy(true);
    try {
      const r = await escalate(sessionId, "");
      toast.success(t("as.sent_toast"));
      onDone(r.ticket_id);
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <button onClick={go} disabled={busy} data-testid="assist-human-btn"
      className="w-full flex items-center justify-center gap-2 text-xs text-slate-400 hover:text-white py-2 transition-colors disabled:opacity-50">
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <UserRound className="w-3.5 h-3.5" />}{t("as.human")}
    </button>
  );
};
